import Service from '../abstract/service'

export default class Prazo extends Service {
  constructor () {
    super()
    this._dataSyncRef = this._db.collection(
      `dev-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
  }

//------------- Sincronização -------------//

    async criaSincronizacao (tipo, value) {
    try {
      await this._dataSyncRef.doc().set({
        ativo: value.ativo,
        dataCriacao: new Date(),
        descricao: tipo,
        empresas: value.empresas
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

//------------- Financiamento -------------//

  async createPrazoFinanciamento (financiamento, prazo, prazoId) {
    try {
      this._loading.setLoading(true, 'Criando Prazo')
      const doc = await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Tabelas/${financiamento.id}/Prazos`
        )
        .doc(prazoId)
      await doc.set(prazo)
      prazo.financiamentoId = financiamento.id
      prazo.id = doc.id

      if (financiamento.ativo) {
        await this.criaSincronizacao('Financiamento', financiamento)
      }

      return Promise.resolve(prazo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

    async getByFinanciamento (financiamento) {
    try {
      this._loading.setLoading(true, 'Carregando Prazos')
      const response = await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Tabelas/${financiamento.id}/Prazos`
        )
        .get()

      let prazos = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          prazos.push({
            financiamentoId: financiamento.id,
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(prazos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async updatePrazoFinanciamento (financiamento, prazo, prazoId) {
    try {
      this._loading.setLoading(true, 'Editando Prazo')
      await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Tabelas/${financiamento.id}/Prazos/`
        )
        .doc(prazoId)
        .update(prazo)
      prazo.id = prazoId
      prazo.financiamentoId = financiamento.id

      if (financiamento.ativo) {
        await this.criaSincronizacao('Financiamento', financiamento)
      }

      return Promise.resolve(prazo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  //------------- Consórcio -------------//

  async createPrazoConsorcio (consorcio, prazo, prazoId) {
    try {
      this._loading.setLoading(true, 'Criando Prazo')
      const doc = await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Planos/${consorcio.id}/Prazos`
        )
        .doc(prazoId)
      await doc.set(prazo)
      prazo.consorcioId = consorcio.id
      prazo.id = doc.id

      if (consorcio.ativo) {
        await this.criaSincronizacao('Consorcio', consorcio)
      }

      return Promise.resolve(prazo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

    async getByConsorcio (consorcio) {
    try {
      this._loading.setLoading(true, 'Carregando Prazos')
      const response = await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Planos/${consorcio.id}/Prazos`
        )
        .get()

      let prazos = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          prazos.push({
            consorcioId: consorcio.id,
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(prazos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async updatePrazoConsorcio (consorcio, prazo, prazoId) {
    try {
      this._loading.setLoading(true, 'Editando Prazo')
      await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Planos/${consorcio.id}/Prazos/`
        )
        .doc(prazoId)
        .update(prazo)
      prazo.id = prazoId
      prazo.consorcioId = consorcio.id

      if (consorcio.ativo) {
        await this.criaSincronizacao('Consorcio', consorcio)
      }

      return Promise.resolve(prazo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  //------------- Financiamento Produto Força -------------//

  async createPrazoFinanciamentoProdutoForca (financiamento, prazo, prazoId) {
    try {
      this._loading.setLoading(true, 'Criando Prazo')
      const doc = await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/TabelasProdutoForca/${financiamento.id}/Prazos`
        )
        .doc(prazoId)
      await doc.set(prazo)
      prazo.financiamentoId = financiamento.id
      prazo.id = doc.id

      if (financiamento.ativo) {
        await this.criaSincronizacao('Financiamento', financiamento)
      }

      return Promise.resolve(prazo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

    async getByFinanciamentoProdutoForca (financiamento) {
    try {
      this._loading.setLoading(true, 'Carregando Prazos')
      const response = await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/TabelasProdutoForca/${financiamento.id}/Prazos`
        )
        .get()

      let prazos = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          prazos.push({
            financiamentoId: financiamento.id,
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(prazos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async updatePrazoFinanciamentoProdutoForca (financiamento, prazo, prazoId) {
    try {
      this._loading.setLoading(true, 'Editando Prazo')
      await this._db
        .collection(
          `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/TabelasProdutoForca/${financiamento.id}/Prazos/`
        )
        .doc(prazoId)
        .update(prazo)
      prazo.id = prazoId
      prazo.financiamentoId = financiamento.id

      if (financiamento.ativo) {
        await this.criaSincronizacao('Financiamento', financiamento)
      }

      return Promise.resolve(prazo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
